import React, { memo } from 'react'
import { View } from '@react-pdf/renderer'
import PropTypes from 'prop-types';

export const Circle = memo(({ type }) => {
  if (type === 'min') return <View style={{ borderRadius: '100%', padding: 3, border: '1px solid black', margin: 2 }} />
  return (
    <View style={{ borderRadius: '100%', padding: 2.5, border: '1px solid #bbb', margin: 2 }} />
  )
})

Circle.propTypes = {
  type: PropTypes.string,
}

